import { useState } from 'react';
import { Button } from '@givebutter/primitives/button';
import { DatePicker } from '@givebutter/primitives/date-picker';
import * as Popover from '@givebutter/primitives/popover';
import { faCalendar, faCalendarXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUpdateTask } from 'components/tasks/utils/useUpdateTask';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { dateFromServer, dateToServerDateTime, isCurrentYear } from 'helpers/dates';
import { DateTime } from 'luxon';
import { Task } from 'types/domain';

const DueAtAction = ({ task }: { task: Task }) => {
    const { timezone } = useCurrentAccount();
    const [isOpen, setIsOpen] = useState(false);
    const { due_at, is_past_due } = task;

    const { mutate } = useUpdateTask();

    if (!due_at) return null;
    return (
        <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
            <Popover.Trigger asChild>
                <Button
                    variant="outline"
                    color="neutral"
                    size="sm"
                    className="z-layerFour font-normal"
                >
                    <FontAwesomeIcon
                        icon={is_past_due ? faCalendarXmark : faCalendar}
                        className={is_past_due ? 'text-red-500' : 'text-gray-500'}
                    />
                    {dateFromServer(due_at).toFormat(
                        `LLL d${isCurrentYear(dateFromServer(due_at)) ? '' : ', yyyy'}`,
                    )}
                </Button>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content align="start" side="bottom">
                    <DatePicker
                        isTextInput={false}
                        selectRange={false}
                        value={dateFromServer(due_at)}
                        onChange={date => {
                            if (!date) return;
                            mutate({
                                taskId: task.id,
                                params: {
                                    due_at: dateToServerDateTime(
                                        (date as DateTime).setZone(timezone).endOf('day'),
                                    ),
                                },
                            });
                            setIsOpen(false);
                        }}
                    />
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
};

export { DueAtAction };
